import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { AgeRatingEnum, PropertySourceEnum } from '~/api/book/bookApiTypes';
import { Popover } from '~/atomic/atom/Popover';
import { Status } from '~/atomic/atom/Status';
import Modal from '~/atomic/molecula/Modal';

interface DrugUseBadgeProps {
  containsDrugUse?: boolean;
  containsDrugUseSource?: PropertySourceEnum;
}

export const DrugUseBadge: FC<DrugUseBadgeProps> = ({
  containsDrugUse,
  containsDrugUseSource,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!containsDrugUse || !containsDrugUseSource) return null;

  const isModerator = containsDrugUseSource === 'moderator';

  if (isModerator) {
    return (
      <>
        <SCRedStatus onClick={() => setIsModalOpen(true)}>
          <SCCannabisIconWhite src="/icon/cannabis.svg" alt="" />
        </SCRedStatus>
        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
        >
          <SCModalText>
            Модератор отметил, что в книге содержится информация о способах или методах
            незаконного производства, приобретения, хранения, перевозки, пересылки, сбыта
            или употребления наркотических средств, психотропных веществ, их аналогов или
            прекурсоров, а также местах их приобретения.
          </SCModalText>
        </Modal>
      </>
    );
  }

  return (
    <Popover
      trigger="click"
      position="bottomLeft"
      header={(
        <SCYellowStatus>
          <SCCannabisIcon src="/icon/cannabis.svg" alt="" />
        </SCYellowStatus>
      )}
    >
      <SCPopoverText>
        Вы указали наличие информации о наркотиках в книге
      </SCPopoverText>
    </Popover>
  );
};

interface AgeRatingModeratorBadgeProps {
  age?: AgeRatingEnum;
  ageRatingSource?: PropertySourceEnum;
}

export const AgeRatingModeratorBadge: FC<AgeRatingModeratorBadgeProps> = ({
  age,
  ageRatingSource,
}) => {
  if (age !== AgeRatingEnum['18+'] || ageRatingSource !== 'moderator') return null;

  return (
    <Popover
      trigger="click"
      position="bottomLeft"
      header={(
        <SCRedStatus>
          18+
        </SCRedStatus>
      )}
    >
      <SCPopoverText>
        Модератор установил для книги возрастное ограничение 18+
      </SCPopoverText>
    </Popover>
  );
};

const SCCannabisIcon = styled.img`
  width: 10px;
  height: 10px;
`;

const SCCannabisIconWhite = styled(SCCannabisIcon)`
  filter: brightness(0) invert(1);
`;

const SCYellowStatus = styled(Status)`
  && {
    background-color: var(--yellow-color);
    padding: 5px 10px;
    cursor: pointer;
  }
`;

const SCRedStatus = styled(Status)`
  && {
    background-color: red;
    color: var(--white-color);
    padding: 5px 10px;
    cursor: pointer;
  }
`;

const SCPopoverText = styled.p`
  font-family: var(--second-font);
  font-size: 13px;
  line-height: 18px;
  color: var(--black-color);
  margin: 0;
  max-width: 250px;
`;

const SCModalText = styled.p`
  font-family: var(--second-font);
  font-size: 14px;
  line-height: 22px;
  color: var(--black-color);
  margin: 0;
`;
